import { browser } from '$app/environment';
import { fetchRequest } from '@server/requests.js';
import currentUserSession from '@utils/currentUserSession';
import { error } from '@sveltejs/kit';
const API_URL = import.meta.env['VITE_API_URL'];
let NProgress;

let setupNprogress = async function () {
  if (browser) {
    NProgress = (await import('nprogress')).default;
  }
};

export async function fetchOpenGraph(id, fetch) {
  let user;

  if (typeof window === 'undefined') {
    try {
      user = await (await fetch(`${API_URL}/api/users/${id}/og`)).json();
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  return {
    id: id,
    user: user,
  };
}

let fetchUser = async function (params, fetch, currentUser) {
  await setupNprogress();
  NProgress && NProgress.start();

  let user;
  try {
    user = await fetchRequest({
      fetch, // passing the provided fetch to fetchRequest
      url: `/users/${params.id}`,
      data: { strict: 1 },
      method: 'GET',
      currentUser: currentUser,
    });
  } catch (err) {
    console.error(err);
  }

  NProgress && NProgress.done();
  // If you need to return data for the component, do it here:
  return user;
  // Add any other necessary data
};

let fetchGroups = async function (params, fetch, currentUser) {
  let response;
  try {
    response = await fetchRequest({
      fetch, // passing the provided fetch to fetchRequest
      url: `/users/${params.id}/profile_page_initial_groups`,
      method: 'GET',
      currentUser: currentUser,
    });
  } catch (err) {
    console.error(err);
  }

  return {
    groups: response?.groups,
    groupSortOrder: response?.groups_sort_order,
  };
};

let fetchGroupCollections = async function (params, fetch, currentUser) {
  let response;
  try {
    response = await fetchRequest({
      fetch, // passing the provided fetch to fetchRequest
      url: `/users/${params.id}/group_collection`,
      method: 'GET',
      currentUser: currentUser,
    });
  } catch (err) {
    console.error(err);
  }

  return {
    groupCollections: response?.group_collections,
    groupCollectionsSortOrder: response?.group_collections_sort_order,
  };
};

export async function load({ parent, params, fetch }) {
  let { currentUser } = await parent();
  if (browser) {
    currentUser = currentUserSession();
  }

  const [og, user, groupData, groupCollectionData] = await Promise.all([
    fetchOpenGraph(params.id, fetch),
    fetchUser(params, fetch, currentUser),
    fetchGroups(params, fetch, currentUser),
    fetchGroupCollections(params, fetch, currentUser),
  ]);

  const { groups } = groupData;
  const { groupCollections, groupCollectionsSortOrder } = groupCollectionData;

  if (!user) {
    throw error(404, { message: 'Not found' });
  }

  return {
    og,
    user,
    currentUser,
    groups,
    groupCollections,
    groupCollectionsSortOrder,
  };
}
